import React, { useState, useEffect } from "react";
import { Tabs, Input, Button, Modal } from "antd";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import { Link } from "react-router-dom";
import "./styles.css";

import "react-pdf/dist/esm/Page/TextLayer.css";

function CertificateModal({ data, display, setDisplay }) {
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [templates, setTemplates] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const handleCancel = () => {
    setDisplay(false);
  };

  return (
    <div className="App">
      <Modal
        title={`Preview Certificate`}
        open={display}
        onCancel={handleCancel}
        width={"50%"}
        footer={null}
      >
        <center>
          <div align="center">
            <table
              border={0}
              cellSpacing={0}
              cellPadding={0}
              width="100%"
              className="aw-bgc"
              align="center"
              role="presentation"
              style={{
                backgroundColor: "rgb(248, 248, 248)",
                fontWeight: 400,
                textSizeAdjust: "100%",
                color: "#23496d",
                fontFamily: "Arial",
                borderCollapse: "collapse",
                borderSpacing: 0,
                borderWidth: 0,
                borderStyle: "none",
                fontSize: 15,
              }}
            >
              <tbody>
                <tr>
                  <td
                    className="temp-wrapper"
                    style={{
                      textSizeAdjust: "100%",
                      color: "#23496d",
                      fontFamily: "Arial",
                      borderCollapse: "collapse",
                      borderSpacing: 0,
                      borderWidth: 0,
                      borderStyle: "none",
                      fontSize: 15,
                    }}
                  >
                    <div align="center">
                      <div className="temp-header" style={{ maxWidth: 600 }}>
                        <div
                          className="temp-fullbleed contained"
                          style={{ maxWidth: 600, width: "100%" }}
                        >
                          <div className="region">
                            <div>
                              <table
                                className="row aw-stack"
                                style={{
                                  width: "100%",
                                  textSizeAdjust: "100%",
                                  color: "#23496d",
                                  fontFamily: "Arial",
                                  borderCollapse: "collapse",
                                  borderSpacing: 0,
                                  borderWidth: 0,
                                  borderStyle: "none",
                                  fontSize: 15,
                                }}
                                role="presentation"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      className="container"
                                      style={{
                                        padding: "30px 20px",
                                        width: "100%",
                                        textSizeAdjust: "100%",
                                        color: "#23496d",
                                        fontFamily: "Arial",
                                        borderCollapse: "collapse",
                                        borderSpacing: 0,
                                        borderWidth: 0,
                                        borderStyle: "none",
                                        fontSize: 15,
                                      }}
                                      width="100%"
                                      valign="top"
                                    ></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="temp-body"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: 10,
                          maxWidth: 600,
                        }}
                      >
                        <div
                          className="temp-fullbleed contained"
                          style={{ maxWidth: 600, width: "100%" }}
                        >
                          <div className="region">
                            <div>
                              <table
                                className="row aw-stack"
                                style={{
                                  width: "100%",
                                  textSizeAdjust: "100%",
                                  color: "#23496d",
                                  fontFamily: "Arial",
                                  borderCollapse: "collapse",
                                  borderSpacing: 0,
                                  borderWidth: 0,
                                  borderStyle: "none",
                                  fontSize: 15,
                                }}
                                role="presentation"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      className="container"
                                      style={{
                                        padding: 0,
                                        width: "100%",
                                        textSizeAdjust: "100%",
                                        color: "#23496d",
                                        fontFamily: "Arial",
                                        borderCollapse: "collapse",
                                        borderSpacing: 0,
                                        borderWidth: 0,
                                        borderStyle: "none",
                                        fontSize: 15,
                                      }}
                                      width="100%"
                                      valign="top"
                                    >
                                      <div className="definition-parent">
                                        <span>
                                          <table
                                            align="center"
                                            width="100%"
                                            className="floated-none"
                                            style={{
                                              float: "none",
                                              textAlign: "center",
                                              textSizeAdjust: "100%",
                                              color: "#23496d",
                                              fontFamily: "Arial",
                                              borderCollapse: "collapse",
                                              borderSpacing: 0,
                                              borderWidth: 0,
                                              borderStyle: "none",
                                              fontSize: 15,
                                            }}
                                            role="presentation"
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  align="right"
                                                  style={{
                                                    padding: 0,
                                                    textSizeAdjust: "100%",
                                                    color: "#23496d",
                                                    fontFamily: "Arial",
                                                    borderCollapse: "collapse",
                                                    borderSpacing: 0,
                                                    borderWidth: 0,
                                                    borderStyle: "none",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  <img
                                                    className="model"
                                                    src={data.logoImage}
                                                    alt="Logo"
                                                    width={150}
                                                    height={41}
                                                  />
                                                </td>
                                              </tr>
                                              <tr>
                                                <td
                                                  align="center"
                                                  style={{
                                                    padding: 0,
                                                    textSizeAdjust: "100%",
                                                    color: "#23496d",
                                                    fontFamily: "Arial",
                                                    borderCollapse: "collapse",
                                                    borderSpacing: 0,
                                                    borderWidth: 0,
                                                    borderStyle: "none",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  <a
                                                    className="aw-image-link"
                                                    href="#"
                                                    style={{
                                                      borderWidth: 0,
                                                      borderStyle: "none",
                                                      textDecoration: "none",
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      className="model"
                                                      src={data.headerImage}
                                                      style={{
                                                        display: "block",
                                                        width: 600,
                                                        height: 283,
                                                        borderWidth: 0,
                                                        borderStyle: "none",
                                                        lineHeight: "100%",
                                                        maxWidth: "100%",
                                                        outlineWidth: "medium",
                                                        outlineStyle: "none",
                                                        textDecoration: "none",
                                                        color: "#23496d",
                                                        fontSize: 20,
                                                        fontWeight: 700,
                                                        borderRadius: 10,
                                                      }}
                                                      alt="Image"
                                                      width={600}
                                                      height={283}
                                                    />
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table
                                className="row aw-stack"
                                style={{
                                  width: "100%",
                                  textSizeAdjust: "100%",
                                  color: "#23496d",
                                  fontFamily: "Arial",
                                  borderCollapse: "collapse",
                                  borderSpacing: 0,
                                  borderWidth: 0,
                                  borderStyle: "none",
                                  fontSize: 15,
                                }}
                                role="presentation"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      className="container"
                                      style={{
                                        padding: 30,
                                        width: "100%",
                                        textSizeAdjust: "100%",
                                        color: "#23496d",
                                        fontFamily: "Arial",
                                        borderCollapse: "collapse",
                                        borderSpacing: 0,
                                        borderWidth: 0,
                                        borderStyle: "none",
                                        fontSize: 15,
                                      }}
                                      width="100%"
                                      valign="top"
                                    >
                                      <div className="definition-parent">
                                        <div className="text-element paragraph">
                                          <div
                                            style={{
                                              color: "#23496d",
                                              fontFamily: "Arial",
                                              fontSize: 15,
                                              lineHeight: "125%",
                                              fontWeight: 400,
                                              textAlign: "left",
                                            }}
                                          >
                                            <p style={{ color: "#23496d" }}>Dear Customer,</p>
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            >
                                              &nbsp;
                                            </p>
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            >
                                              {data.bodyFirstParagraph}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5>
                                <span style={{ textAlign: "center" }}>
                                  <p style={{ textDecoration: "none", color: "black" }}>
                                    View My Certificate
                                  </p>{" "}
                                </span>
                              </h5>
                              <table
                                className="row aw-stack"
                                style={{
                                  width: "100%",
                                  textSizeAdjust: "100%",
                                  color: "#23496d",
                                  fontFamily: "Arial",
                                  borderCollapse: "collapse",
                                  borderSpacing: 0,
                                  borderWidth: 0,
                                  borderStyle: "none",
                                  fontSize: 15,
                                }}
                                role="presentation"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      className="container"
                                      style={{
                                        padding: 30,
                                        width: "100%",
                                        textSizeAdjust: "100%",
                                        color: "#23496d",
                                        fontFamily: "Arial",
                                        borderCollapse: "collapse",
                                        borderSpacing: 0,
                                        borderWidth: 0,
                                        borderStyle: "none",
                                        fontSize: 15,
                                      }}
                                      width="100%"
                                      valign="top"
                                    >
                                      <div className="definition-parent">
                                        <div className="text-element paragraph">
                                          <div
                                            style={{
                                              color: "#23496d",
                                              fontFamily: "Arial",
                                              fontSize: 15,
                                              lineHeight: "125%",
                                              fontWeight: 400,
                                              textAlign: "left",
                                            }}
                                          >
                                            <p style={{ color: "#23496d" }}>
                                              {data.bodyParagraph2}
                                            </p>
                                            <br />
                                            <p style={{ color: "#23496d" }}>
                                              <a href="{projectlink}">{data.templateName}</a>
                                            </p>{" "}
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            >
                                              &nbsp;
                                            </p>
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            >
                                              &nbsp;
                                            </p>
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            ></p>
                                            <p style={{ color: "#23496d" }}>
                                              {data.bodyParagraph3}
                                            </p>
                                            <p />
                                            <p
                                              style={{
                                                color: "#23496d",
                                                fontFamily: "Arial",
                                                fontSize: 15,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                                textAlign: "left",
                                              }}
                                            >
                                              &nbsp;
                                            </p>
                                            <p style={{ color: "#23496d" }}>
                                              {data.bodyParagraph4}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <br />
                                      <br />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="temp-footer" style={{ maxWidth: 600 }}>
                        <div
                          className="temp-fullbleed contained"
                          style={{ maxWidth: 600, width: "100%" }}
                        >
                          <div className="region">
                            <div>
                              <table
                                className="row aw-stack"
                                style={{
                                  width: "100%",
                                  textSizeAdjust: "100%",
                                  color: "#23496d",
                                  fontFamily: "Arial",
                                  borderCollapse: "collapse",
                                  borderSpacing: 0,
                                  borderWidth: 0,
                                  borderStyle: "none",
                                  fontSize: 15,
                                }}
                                role="presentation"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      className="container"
                                      style={{
                                        padding: "30px 20px",
                                        width: "100%",
                                        textSizeAdjust: "100%",
                                        color: "#23496d",
                                        fontFamily: "Arial",
                                        borderCollapse: "collapse",
                                        borderSpacing: 0,
                                        borderWidth: 0,
                                        borderStyle: "none",
                                        fontSize: 15,
                                      }}
                                      width="100%"
                                      valign="top"
                                    >
                                      <div className="definition-parent">
                                        <div className="social social--sm social--circle align-center">
                                          <table
                                            cellPadding={0}
                                            cellSpacing={0}
                                            width="100%"
                                            role="presentation"
                                            style={{
                                              textSizeAdjust: "100%",
                                              color: "#23496d",
                                              fontFamily: "Arial",
                                              borderCollapse: "collapse",
                                              borderSpacing: 0,
                                              borderWidth: 0,
                                              borderStyle: "none",
                                              fontSize: 15,
                                            }}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  align="center"
                                                  style={{
                                                    padding: "0.625rem 0px",
                                                    textSizeAdjust: "100%",
                                                    color: "#23496d",
                                                    fontFamily: "Arial",
                                                    borderCollapse: "collapse",
                                                    borderSpacing: 0,
                                                    borderWidth: 0,
                                                    borderStyle: "none",
                                                    fontSize: 15,
                                                  }}
                                                >
                                                  <a
                                                    href={data.faceBookUrl}
                                                    style={{
                                                      display: "inline-block",
                                                      fontSize: 0,
                                                      verticalAlign: "top",
                                                      margin: "0.25rem",
                                                      height: 24,
                                                      width: 24,
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      style={{
                                                        height: 24,
                                                        width: 24,
                                                        borderWidth: 0,
                                                        borderStyle: "none",
                                                        lineHeight: "100%",
                                                        maxWidth: "100%",
                                                        outlineWidth: "medium",
                                                        outlineStyle: "none",
                                                        textDecoration: "none",
                                                        color: "#23496d",
                                                        fontSize: 20,
                                                        fontWeight: 700,
                                                        borderRadius: 10,
                                                      }}
                                                      alt="Facebook Icon"
                                                      src="https://gcsdevsa.blob.core.windows.net/emailassets/facebook_circle_grey.png"
                                                      data-icon-name="Facebook"
                                                      height={24}
                                                      width={24}
                                                    />
                                                  </a>
                                                  <a
                                                    href={data.instagramUrl}
                                                    style={{
                                                      display: "inline-block",
                                                      fontSize: 0,
                                                      verticalAlign: "top",
                                                      margin: "0.25rem",
                                                      height: 24,
                                                      width: 24,
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      style={{
                                                        height: 24,
                                                        width: 24,
                                                        borderWidth: 0,
                                                        borderStyle: "none",
                                                        lineHeight: "100%",
                                                        maxWidth: "100%",
                                                        outlineWidth: "medium",
                                                        outlineStyle: "none",
                                                        textDecoration: "none",
                                                        color: "#23496d",
                                                        fontSize: 20,
                                                        fontWeight: 700,
                                                        borderRadius: 10,
                                                      }}
                                                      alt="Instagram Icon"
                                                      src="https://gcsdevsa.blob.core.windows.net/emailassets/instagram_circle_grey.png"
                                                      data-icon-name="Instagram"
                                                      height={24}
                                                      width={24}
                                                    />
                                                  </a>
                                                  <a
                                                    href={data.linkedInUrl}
                                                    style={{
                                                      display: "inline-block",
                                                      fontSize: 0,
                                                      verticalAlign: "top",
                                                      margin: "0.25rem",
                                                      height: 24,
                                                      width: 24,
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      style={{
                                                        height: 24,
                                                        width: 24,
                                                        borderWidth: 0,
                                                        borderStyle: "none",
                                                        lineHeight: "100%",
                                                        maxWidth: "100%",
                                                        outlineWidth: "medium",
                                                        outlineStyle: "none",
                                                        textDecoration: "none",
                                                        color: "#23496d",
                                                        fontSize: 20,
                                                        fontWeight: 700,
                                                        borderRadius: 10,
                                                      }}
                                                      alt="LinkedIn Icon"
                                                      src="https://gcsdevsa.blob.core.windows.net/emailassets/linkedin_circle_grey.png"
                                                      data-icon-name="YouTube"
                                                      height={24}
                                                      width={24}
                                                    />
                                                  </a>
                                                  <a
                                                    href={data.webUrl}
                                                    style={{
                                                      display: "inline-block",
                                                      fontSize: 0,
                                                      verticalAlign: "top",
                                                      margin: "0.25rem",
                                                      height: 24,
                                                      width: 24,
                                                    }}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    <img
                                                      style={{
                                                        height: 24,
                                                        width: 24,
                                                        borderWidth: 0,
                                                        borderStyle: "none",
                                                        lineHeight: "100%",
                                                        maxWidth: "100%",
                                                        outlineWidth: "medium",
                                                        outlineStyle: "none",
                                                        textDecoration: "none",
                                                        color: "#23496d",
                                                        fontSize: 20,
                                                        fontWeight: 700,
                                                        borderRadius: 10,
                                                      }}
                                                      alt="Website Icon"
                                                      src="https://gcsdevsa.blob.core.windows.net/emailassets/website_circle_grey.png"
                                                      data-icon-name="LinkedIn"
                                                      height={24}
                                                      width={24}
                                                    />
                                                  </a>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                      <div className="definition-parent">
                                        <div className="text-element paragraph">
                                          <div
                                            style={{
                                              color: "rgb(124, 124, 124)",
                                              fontFamily: "Arial",
                                              fontSize: 14,
                                              lineHeight: "125%",
                                              fontWeight: 400,
                                              textAlign: "left",
                                            }}
                                          >
                                            <div
                                              style={{
                                                textAlign: "center",
                                                color: "rgb(124, 124, 124)",
                                                fontFamily: "Arial",
                                                fontSize: 14,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                              }}
                                            >
                                              &nbsp;
                                            </div>
                                            <div
                                              style={{
                                                textAlign: "center",
                                                color: "rgb(124, 124, 124)",
                                                fontFamily: "Arial",
                                                fontSize: 14,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {" "}
                                              {data.footerText} <br />
                                              {data.footerText2}
                                            </div>
                                            <div
                                              style={{
                                                textAlign: "center",
                                                color: "rgb(124, 124, 124)",
                                                fontFamily: "Arial",
                                                fontSize: 14,
                                                lineHeight: "125%",
                                                fontWeight: 400,
                                              }}
                                            >
                                              <br />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </center>
      </Modal>
    </div>
  );
}

export default CertificateModal;
